import { useCallback, useEffect, useState } from 'react';
import Viewer from '../eMapping/3dView/Viewer';
import { Space } from '@smplrspace/smplr-loader/dist/generated/smplr';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { getFacilityDeviceLocations } from '../../store/thunk/locationThunk';
import { DeviceColors } from './emapView';
import { SmplrCoord3d } from '../eMapping/3dView/types';

type Props = {
    spaceId: string;
    tenantCode: string;
    facilityId: string;
    deviceColors: { [key: string]: Partial<DeviceColors> },
    redirectToOverview: (deviceLocationId: string, facilityId: string) => void
}

const ThreeDView = ({ spaceId, tenantCode, facilityId, deviceColors, redirectToOverview }: Props) => {
    const [space, setSpace] = useState<Space>();
    const onReady = useCallback((space: Space | undefined) => setSpace(space), []);
    const dispatch = useAppDispatch();
    // const points = useAppSelector(store => store?.locationSlice?.currentFacilityDeviceLocations);
    const threeDDevices = useAppSelector(store => store?.locationSlice?.currentFacilityDeviceLocations);
    const [points, setPoints] = useState<{
        id: string;
        name: string;
        position: SmplrCoord3d;
    }[]>([]);
    const configuredDevices = useAppSelector((store) => store?.deviceSlice?.configureListNew || [])
    useEffect(() => {
        const devices: {
            id: string;
            name: string;
            position: SmplrCoord3d;
        }[] = [];
        threeDDevices?.map((device) => {
            const isLocationExists = configuredDevices?.find((loc: any) => loc?.sk === device?.id)?.loc;
            if (isLocationExists) {
                devices.push({
                    id: device?.id,
                    name: (isLocationExists?.provider ? `${isLocationExists?.provider}: ` : "") + device?.name,
                    position: device?.position as SmplrCoord3d,
                });
            }
            return device;
        });
        setPoints(devices || []);
    }, [JSON.stringify(configuredDevices), JSON.stringify(threeDDevices)]);
    useEffect(() => {
        if (!space) return;
        space.removeDataLayer('points');
        space?.addDataLayer({
            id: 'points',
            type: 'point',
            shape: 'sphere',
            // color: '#1e7bd3',
            color: d => (deviceColors[d?.id]?.color || '#FFFFFF'),
            data: points || [],
            diameter: 0.5,
            anchor: 'bottom',
            tooltip: (d) => d.name,
            onClick(dataElement, event) {
                redirectToOverview(deviceColors[dataElement?.id]?.loc || "", deviceColors[dataElement?.id]?.flr || "");
                // console.log(deviceColors[dataElement?.id], location.filter((value: any) => value?.parentKey === deviceColors[dataElement?.id]?.flr), 'helllo');
            },
        });
        // return () => space.removeDataLayer('points');
    }, [points, space, JSON.stringify(deviceColors)]);
    useEffect(() => {
        if (tenantCode && facilityId)
            dispatch(getFacilityDeviceLocations({ tenantCode, facilityKey: facilityId }));
    }, [tenantCode, facilityId]);
    const onError = useCallback((error: any) => {
        console.log("error ", error);
    }, [space]);
    return (
        <div style={{ display: "flex", justifyContent: 'center', marginTop: '1em', height: "35em" }}>
            <Viewer containerStyle={{ aspectRatio: "20/10", }} onReady={onReady} onError={onError} spaceId={spaceId} mode="3d" space={space} />
        </div>
    )
}

export default ThreeDView